const bodyLocks = new WeakMap();

// Dialogs may close or unmount in a different order from the order they opened.
// Keep the page's original overflow until the last owner releases its lock.
export function lockBodyScroll() {
  const body = typeof document === 'undefined' ? null : document.body;
  if (!body) return () => {};

  let lock = bodyLocks.get(body);
  if (!lock) {
    lock = {
      count: 0,
      overflow: body.style.getPropertyValue('overflow'),
      priority: body.style.getPropertyPriority('overflow'),
    };
    bodyLocks.set(body, lock);
    body.style.setProperty('overflow', 'hidden', lock.priority);
  }
  lock.count += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    lock.count -= 1;
    if (lock.count > 0) return;
    body.style.setProperty('overflow', lock.overflow, lock.priority);
    bodyLocks.delete(body);
  };
}
